module.exports = __webpack_public_path__ + "static/sorrowful_4-9b42bf5da32ca3a79046b09a9bc1d557.jpg";